/* eslint-disable jsx-a11y/alt-text */
import "../styles/Intro.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Signup from "./Signup.js";
import Login from "./Login.js";
import Dashboard from "./Dashboard.js";
import Profile from "./UserProfile.js";
import EligibilityForm from "./Eligibilityform.js";
import logo from '../images/byteedu.png';
import GovScheme from "./GovScheme.js";
function Intro() {
  return (
    <Router>
      <div className="home-container">
        <img src={logo} style={{backgroundColor:'white',borderRadius:'30px'}}/>
        <h1 style={{marginTop:'0px'}}>Welcome to Upkartam</h1>
        {/* <hr /> */}
        <h3 style={{ textAlign: 'center', fontWeight: 'bold', color: 'white' }}>By ByteEdu</h3>
        <p style={{ color: 'yellow', fontWeight: 'bold' }}>
        पात्रता की जांच करने और सरकारी योजनाओं के लिए आवेदन करने के लिए आपका वन-स्टॉप समाधान</p>
        <p style={{ color: 'yellow', fontWeight: 'bold' }}>कृपया लॉगिन करें यदि आप मौजूदा उपयोगकर्ता हैं।</p>
        <br/>
        <p style={{ color: 'yellow', fontWeight: 'bold' }}>यदि आप नए उपयोगकर्ता हैं, तो कृपया साइन अप करें।</p>
        <div className="button-group">
          <Link to="/login"><button className="btn">Login</button></Link>
          <Link to="/signup"><button className="btn">Sign Up</button></Link>
          <Link to="/dashboard"><button className="btn">Dashboard</button></Link>
          <Link to="/eligibility"><button className="btn">Check Eligibility</button></Link>
          <Link to="/Profile"><button className="btn">USER PROFILE</button></Link>
          <Link to="/GovScheme"><button className="btn">Goverment Scheme</button></Link>
        </div>
      </div>

      <Routes>
        <Route path="/signup" element={<Signup />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/eligibility" element={<EligibilityForm />} />
        <Route path="/GovScheme" element={<GovScheme/>}/>
      </Routes>
    </Router>
  );
}

export default Intro;